import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { questions, responses, language } = location.state || {
    questions: [],
    responses: {},
    language: "en",
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPalette, setShowPalette] = useState(false);
  const [currentLang, setCurrentLang] = useState(language);
const summary = questions.reduce(
    (acc, question, index) => {
      const correct = parseInt(question.correct_option);
      const response = responses[index];
      if (response === undefined) {
        acc.notAttempted++;
      } else if (response + 1 === correct) {
        acc.correct++;
      } else {
        acc.incorrect++;
      }
      return acc;
    },
    { correct: 0, incorrect: 0, notAttempted: 0 }
  );
  

  // For swipe handling
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(0);
  const contentRef = useRef(null);
  const [animDirection, setAnimDirection] = useState(null); // "left" or "right"

  const getOption = (q, n) =>
    currentLang === "hi" ? q[`option${n}_hi`] : q[`option${n}_en`];

  const getQuestionText = (q) =>
    currentLang === "hi" ? q.question_text_hi : q.question_text_en;

  const getSolution = (q) =>
    currentLang === "hi" ? q.solution_hi : q.solution_en;

  // Swipe handlers
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!startX || !endX) return;

    const diff = startX - endX;
    const threshold = 50; // min px for swipe

    if (diff > threshold && currentIndex < questions.length - 1) {
      // swipe left => next question
      setAnimDirection("left");
      setTimeout(() => {
        setCurrentIndex((idx) => idx + 1);
        setAnimDirection(null);
      }, 300);
    } else if (diff < -threshold && currentIndex > 0) {
      // swipe right => prev question
      setAnimDirection("right");
      setTimeout(() => {
        setCurrentIndex((idx) => idx - 1);
        setAnimDirection(null);
      }, 300);
    }

    setStartX(0);
    setEndX(0);
  };

  // Select question from palette
  const goToQuestion = (idx) => {
    if (idx === currentIndex) return;
    setAnimDirection(idx > currentIndex ? "left" : "right");
    setTimeout(() => {
      setCurrentIndex(idx);
      setAnimDirection(null);
    }, 300);
    setShowPalette(false);
  };

  // Language switcher handler
  const toggleLanguage = () => {
    setCurrentLang((prev) => (prev === "en" ? "hi" : "en"));
  };

 // Go home handler
  const handleGoHome = () => {
    navigate("/");
  };

  const question = questions[currentIndex];
  const correctOption = question ? parseInt(question.correct_option) : null;
  const userAnswerIndex = responses[currentIndex];
  const userAnswer = userAnswerIndex !== undefined ? userAnswerIndex + 1 : null;

  return (
    <>
      {/* Fixed Header */}
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          backgroundColor: "#343a40",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          padding: "0 15px",
          zIndex: 1000,
          justifyContent: "space-between",
          userSelect: "none",
        }}
      >
        <button
          onClick={() => setShowPalette((v) => !v)}
          style={{
            background: "none",
            border: "none",
            color: "white",
            fontSize: 28,
            cursor: "pointer",
          }}
          aria-label="Toggle Question Palette"
        >
          ☰
        </button>

        <h2 style={{ margin: 0, fontSize: 20 }}>
          View Solutions ({currentIndex + 1} / {questions.length})
        </h2>

        <button
          onClick={toggleLanguage}
          style={{
            backgroundColor: "#495057",
            border: "none",
            borderRadius: 4,
            padding: "6px 12px",
            color: "white",
            cursor: "pointer",
            fontWeight: "bold",
          }}
          aria-label="Switch Language"
          title="Switch Language"
        >
          {currentLang === "en" ? "English" : "हिन्दी"}
        </button>
      </header>

      {/* Question Palette Sidebar (slide-in) */}
      <nav
        style={{
          position: "fixed",
          top: 60,
          left: showPalette ? 0 : "-240px",
          width: 240,
          height: "calc(100% - 60px)",
          backgroundColor: "#f8f9fa",
          borderRight: "1px solid #ccc",
          overflowY: "auto",
          transition: "left 0.3s ease",
          zIndex: 1001,
          padding: "15px",
        }}
        aria-label="Question Palette"
      >
        {/* Summary Box */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              background: "#e9ecef",
              borderRadius: "10px",
              marginBottom: "15px",
              fontSize: "15px",
              padding: "10px",
            }}
          >
            <div><strong>Total:</strong> {questions.length}</div>
            <div style={{ color: "green" }}><strong>Correct:</strong> {summary.correct}</div>
            <div style={{ color: "red" }}><strong>Incorrect:</strong> {summary.incorrect}</div>
            <div style={{ color: "gray" }}><strong>Not Attempted:</strong> {summary.notAttempted}</div>
            </div>
        <h3 style={{ marginTop: 0 }}> Question </h3>
  
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "8px",
          }}
        >
          {questions.map((q, idx) => {
            const answeredIndex = responses[idx];
            const answered = answeredIndex !== undefined;
            const correct = parseInt(q.correct_option);
            const selected = answeredIndex + 1 === correct;

            let bg = "#e2e3e5"; // default gray
            let color = "#000";
            if (!answered) {
              bg = "#f8f9fa"; // light bg for not answered
            } else if (selected) {
              bg = "#d4edda"; // green if correct
              color = "#155724";
            } else {
              bg = "#f8d7da"; // red if wrong
              color = "#721c24";
            }

            return (
              <button
                key={idx}
                onClick={() => goToQuestion(idx)}
                style={{
                  backgroundColor: bg,
                  color,
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  padding: "8px",
                  cursor: "pointer",
                  fontWeight: idx === currentIndex ? "bold" : "normal",
                  boxShadow:
                    idx === currentIndex
                      ? "0 0 5px 2px rgba(0,123,255,.5)"
                      : "none",
                }}
                aria-current={idx === currentIndex ? "true" : "false"}
                aria-label={`Question ${idx + 1}`}
                title={`Question ${idx + 1}`}
              >
                {idx + 1}
              </button>
           
            );
          })}
        </div>
      </nav>

      {/* Content container */}
     <main
  ref={contentRef}
  onTouchStart={handleTouchStart}
  onTouchMove={handleTouchMove}
  onTouchEnd={handleTouchEnd}
  style={{
    marginTop: 60,
    marginLeft: showPalette ? 240 : 0,
    marginBottom: 60,
    padding: "20px",
    height: "calc(100vh - 120px)",
    overflowY: "auto",
    transition: "margin-left 0.3s ease",
    position: "relative",
  }}
>
  {question ? (
    <div
      key={question.id}
      className={`slide-animation ${
        animDirection === "left"
          ? "slide-left"
          : animDirection === "right"
          ? "slide-right"
          : ""
      }`}
      style={{
        backgroundColor: "#f9f9f9",
        padding: 15,
        borderRadius: 8,
        boxShadow: "0 2px 8px rgb(0 0 0 / 0.1)",
        minHeight: "calc(100% - 40px)",
      }}
    >
      <div style={{ marginBottom: "15px" }}>
        Q{currentIndex + 1}.{" "}
        <div
          dangerouslySetInnerHTML={{ __html: getQuestionText(question) }}
        />
      </div>
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {[1, 2, 3, 4].map((n) => {
          const isCorrect = correctOption === n;
          const isSelected = userAnswer === n;

          let bg = "#fff";
          let border = "#ccc";
          let icon = "";

          if (isCorrect && isSelected) {
            bg = "#d4edda";
            border = "#28a745";
            icon = "✅";
          } else if (isCorrect && !isSelected) {
            bg = "#d4edda";
            border = "#28a745";
            icon = "✔️";
          } else if (!isCorrect && isSelected) {
            bg = "#f8d7da";
            border = "#dc3545";
            icon = "❌";
          }

          return (
            <li
              key={n}
              style={{
                backgroundColor: bg,
                border: `1px solid ${border}`,
                padding: "8px 12px",
                marginBottom: "8px",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: `(${String.fromCharCode(64 + n)}) ${getOption(
                    question,
                    n
                  )}`,
                }}
              />
              {icon && (
                <span style={{ fontSize: "18px", marginLeft: "10px" }}>
                  {icon}
                </span>
              )}
            </li>
          );
        })}
      </ul>
      <div style={{ marginTop: "12px", fontSize: "15px" }}>
        <strong>Explanation:</strong>{" "}
        <span
          dangerouslySetInnerHTML={{
            __html: getSolution(question),
          }}
        />
      </div>
    </div>
  ) : (
    <p>No questions found.</p>
  )}
</main>
      
 {/* Fixed Footer */}
      <footer
        style={{
          position: "fixed",
          bottom: 0,
          left: showPalette ? 240 : 0,
          right: 0,
          height: 60,
          backgroundColor: "#343a40",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          padding: "0 15px",
          color: "white",
          transition: "left 0.3s ease",
          zIndex: 1000,
        }}
      >
        <button
onClick={() => navigate('/download-pdf', {
    state: {
      questions: questions,
      responses: responses,
      language: language
    }
  })}
          style={{
            backgroundColor: "#28a745",
         
            border: "none",
            padding: "5px 6px",
            borderRadius: 6,
            color: "#fff",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Download PDF
        </button>
         <button
          onClick={handleGoHome}
          style={{
            backgroundColor: "#6c757d",
            border: "none",
            padding: "5px 6px",
            borderRadius: 6,
            color: "#fff",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Go Home
        </button>
        
         <button
          disabled={currentIndex === 0}
          onClick={() => goToQuestion(currentIndex - 1)}
       style={{
            backgroundColor: "#007bff",
         
            border: "none",
            padding: "5px 6px",
            borderRadius: 6,
            color: "#fff",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Previous
        </button>
        <button
        style={{
            backgroundColor: "#007bff",
         
            border: "none",
            padding: "5px 6px",
            borderRadius: 6,
            color: "#fff",
            cursor: "pointer",
            fontWeight: "bold",
          }}
          disabled={currentIndex === questions.length - 1}
          onClick={() => goToQuestion(currentIndex + 1)}
        >
          Next
        </button>
        

      </footer>

      {/* Animation CSS */}
      <style>{`
        .slide-left {
          animation: slideInLeft 0.3s forwards;
        }
        .slide-right {
          animation: slideInRight 0.3s forwards;
        }
        @keyframes slideInLeft {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideInRight {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

export default ResultPage;